import { httpRequest } from '@/services/httpClient'

export type OrganizationTypeItem = {
  id: number
  code: string
  name: string
  language: string
  sortOrder: number
  isActive: boolean
  createdAt: string
  updatedAt: string | null
}

export type OrganizationTypeListResponse = {
  items: OrganizationTypeItem[]
  totalCount: number
  page: number
  pageSize: number
}

export type OrganizationTypeListParams = {
  lang: string
  search?: string
  page?: number
  pageSize?: number
  sortBy?: 'code' | 'name' | 'language' | 'sortOrder' | 'updatedAt'
  sortDir?: 'asc' | 'desc'
}

export type OrganizationTypeCreateUpdatePayload = {
  code: string
  name: string
  language: string
  sortOrder?: number
  isActive?: boolean
}

export type OrganizationTypeCreateResponse = {
  id: number
  code: string
  name: string
  language: string
}

export const LANGUAGES = [
  { value: 'tr', label: 'Türkçe' },
  { value: 'en', label: 'English' },
  { value: 'az', label: 'Azərbaycan' },
] as const

export const organizationTypesApi = {
  list: (params: OrganizationTypeListParams) =>
    httpRequest<OrganizationTypeListResponse>('/v1/lookups/organization-types', {
      method: 'GET',
      query: {
        lang: params.lang,
        search: params.search?.trim() || undefined,
        page: params.page ?? 1,
        pageSize: params.pageSize ?? 10,
        sortBy: params.sortBy,
        sortDir: params.sortDir,
      },
    }),

  getById: (id: number) =>
    httpRequest<OrganizationTypeItem>(`/v1/lookups/organization-types/${id}`, { method: 'GET' }),

  create: (payload: OrganizationTypeCreateUpdatePayload) =>
    httpRequest<OrganizationTypeCreateResponse>('/v1/lookups/organization-types', {
      method: 'POST',
      body: payload,
    }),

  update: (id: number, payload: OrganizationTypeCreateUpdatePayload) =>
    httpRequest<OrganizationTypeItem>(`/v1/lookups/organization-types/${id}`, {
      method: 'PUT',
      body: payload,
    }),

  delete: (id: number) =>
    httpRequest<undefined>(`/v1/lookups/organization-types/${id}`, { method: 'DELETE' }),
}
